<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:37:28
 * @FilePath: \mrc-ess-fronted\src\Layout\components\SlideLeft.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-08-17 15:39:06
 -->
<template>
  <v-navigation-drawer
    elevation="0"
    class="slideLeft_container"
    width="240"
    v-if="!hidden"
    v-model="drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list>
      <v-list-item-group
        color="primary"
        v-model="list"
        active-class="mrc_item_active primary--text"
      >
        <template v-for="item in naviData" v-if="!isDemo">
          <div :key="`div${item.uuid}`">
            <v-list-item
              :key="`pri${item.uuid}`"
              :input-value="curNavKey == item.uuid"
              v-if="!item.menus_tree"
              class="text-caption mrc_listitem_container"
              :class="
                curNavKey == item.uuid
                  ? 'mrc_item_active primary--text v-list-item--active'
                  : ''
              "
              :value="item.uuid"
              @click="toRouter(item.url, item.uuid)"
            >
              <template v-slot:default="{ active, toggle }">
                <v-list-item-content>
                  <v-list-item-title
                    class="line-clamp3"
                    :class="
                      active || curNavKey == item.uuid
                        ? 'text-subtitle-2'
                        : 'text-body-2'
                    "
                  >
                    <!-- {{ item.title }} -->
                    {{ $getCommonLangValue(item.menu_name) }}
                  </v-list-item-title>
                  <v-list-item-action
                    class="dot_active"
                    v-if="curNavKey == item.uuid"
                  >
                    <v-sheet color="primary" class="dot pa-0"></v-sheet>
                  </v-list-item-action>
                </v-list-item-content>
              </template>
            </v-list-item>
            <v-list-group
              v-else
              :key="item.uuid"
              no-action
              :value="
                item.open === undefined ? isMenuActive(item.uuid) : item.open
              "
              append-icon="keyboard_arrow_down"
            >
              <template v-slot:prependIcon v-if="item.menu_icon" class="mr-2">
                <!-- <svg-icon size="24"
                          fill="currentColor"
                          :iconClass="item.meta.icon"
                          v-if="item.menu_icon" /> -->
              </template>
              <!-- <template v-slot:prependIcon
                        v-else-if="item.meta.icon">
                <span class="material-icons-round text--secondary text--lighten-1">
                  {{
                  item.meta.icon
                }}
                </span>
              </template> -->
              <template v-slot:activator>
                <v-list-item-content class="mrc_listitem_container">
                  <v-list-item-title
                    class="line-clamp3 text-body-2"
                    :class="item.open ? 'primary--text' : ''"
                  >
                    {{ $getCommonLangValue(item.menu_name) }}
                    <!-- -{{ item.url }} -->
                    <!-- 父级 -->
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="it in item.menus_tree">
                <v-list-group
                  v-if="it.menus_tree"
                  :key="it.uuid"
                  sub-group
                  no-action
                  :value="
                    it.open === undefined ? isMenuActive(it.uuid) : it.open
                  "
                >
                  <template v-slot:activator>
                    <v-list-item-content
                      class="pl-0 ml-0 mrc_listitem_container"
                      :value="it.uuid"
                    >
                      <!-- <v-list-item-avatar>
                        <span class="material-icons-round">
                          {{ active ? "arrow_right" : "arrow_left" }}
                        </span>
                      </v-list-item-avatar>-->
                      <v-list-item-title
                        class="line-clamp3 text-body-2"
                        :class="it.open ? 'primary--text' : ''"
                      >
                        {{ $getCommonLangValue(it.menu_name) }}
                        <!-- -{{ it.url }} -->
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="i in it.menus_tree"
                    :key="i.uuid"
                    :input-value="curNavKey == i.uuid"
                    class="mrc_listitem_container"
                    :class="
                      curNavKey == i.uuid
                        ? 'mrc_item_active primary--text v-list-item--active'
                        : ''
                    "
                    @click="toRouter(i.url, i.uuid)"
                    :value="i.uuid"
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-content>
                        <v-list-item-title
                          class="line-clamp3"
                          :class="
                            active || curNavKey == i.uuid
                              ? 'text-subtitle-2'
                              : 'text-body-2'
                          "
                        >
                          {{ $getCommonLangValue(i.menu_name) }}
                          <!-- -{{ i.url }} -->
                        </v-list-item-title>
                        <v-list-item-action
                          class="dot_active"
                          v-if="active || curNavKey == i.uuid"
                        >
                          <v-sheet color="primary" class="pa-0 dot"></v-sheet>
                        </v-list-item-action>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </v-list-group>
                <v-list-item
                  :key="it.uuid"
                  :value="it.uuid"
                  :input-value="curNavKey == it.uuid"
                  class="mrc_listitem_container"
                  :class="
                    curNavKey == it.uuid
                      ? 'mrc_item_active primary--text v-list-item--active'
                      : ''
                  "
                  v-else
                  @click="toRouter(it.url, it.uuid)"
                >
                  <template v-slot:default="{ active, toggle }">
                    <!-- <span class="material-icons-round">{{ it.meta.icon }}</span> -->
                    <v-list-item-title
                      class="line-clamp3"
                      :class="
                        active || curNavKey == it.uuid
                          ? 'text-subtitle-2'
                          : 'text-body-2'
                      "
                    >
                      <!-- {{ it.title }} -->
                      {{ $getCommonLangValue(it.menu_name) }}
                      <!-- -{{ it.url }} -->
                      <!-- 子级 -->
                    </v-list-item-title>
                    <v-list-item-action
                      class="dot_active"
                      v-if="active || curNavKey == it.uuid"
                    >
                      <v-sheet color="primary" class="dot pa-0"></v-sheet>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-group>
            <v-divider></v-divider>
          </div>
        </template>
        <!-- 

          演示模式

         -->
        <template v-for="item in naviData" v-if="isDemo">
          <div :key="`div${item.id}`">
            <v-list-item
              :key="`pri${item.id}`"
              v-if="!item.children"
              class="text-caption mrc_listitem_container"
              :value="item.id"
              @click="toRouter(item.path)"
            >
              <template v-slot:default="{ active, toggle }">
                <v-list-item-content>
                  <v-list-item-title
                    class="line-clamp3"
                    :class="active ? 'text-subtitle-2' : 'text-body-2'"
                    >{{ item.title }}</v-list-item-title
                  >
                  <v-list-item-action class="dot_active" v-if="active">
                    <v-sheet color="primary" class="dot pa-0"></v-sheet>
                  </v-list-item-action>
                </v-list-item-content>
              </template>
            </v-list-item>
            <v-list-group
              v-else
              :key="item.id"
              :value="false"
              no-action
              append-icon="keyboard_arrow_down"
            >
              <template v-slot:prependIcon v-if="item.meta.isSvg" class="mr-2">
                <svg-icon
                  size="24"
                  fill="currentColor"
                  :iconClass="item.meta.icon"
                  v-if="item.meta.isSvg"
                />
              </template>
              <template v-slot:prependIcon v-else-if="item.meta.icon">
                <span
                  class="material-icons-round text--secondary text--lighten-1"
                  >{{ item.meta.icon }}</span
                >
              </template>
              <template v-slot:activator>
                <v-list-item-content class="mrc_listitem_container">
                  <v-list-item-title class="line-clamp3 text-body-2">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="it in item.children">
                <v-list-group
                  v-if="it.children"
                  :key="it.id"
                  sub-group
                  no-action
                  :value="false"
                >
                  <template v-slot:activator>
                    <v-list-item-content
                      class="pl-0 ml-0 mrc_listitem_container"
                      :value="it.id"
                    >
                      <!-- <v-list-item-avatar>
                        <span class="material-icons-round">
                          {{ active ? "arrow_right" : "arrow_left" }}
                        </span>
                      </v-list-item-avatar>-->
                      <v-list-item-title class="line-clamp3 text-body-2">{{
                        it.title
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="i in it.children"
                    :key="i.id"
                    class="mrc_listitem_container"
                    @click="toRouter(i.path)"
                    :value="i.id"
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-content>
                        <v-list-item-title
                          class="line-clamp3"
                          :class="active ? 'text-subtitle-2' : 'text-body-2'"
                          >{{ i.title }}</v-list-item-title
                        >
                        <v-list-item-action class="dot_active" v-if="active">
                          <v-sheet color="primary" class="pa-0 dot"></v-sheet>
                        </v-list-item-action>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </v-list-group>
                <v-list-item
                  :key="it.id"
                  :value="it.id"
                  class="mrc_listitem_container"
                  v-else
                  @click="toRouter(it.path)"
                >
                  <template v-slot:default="{ active, toggle }">
                    <!-- <span class="material-icons-round">{{ it.meta.icon }}</span> -->
                    <v-list-item-title
                      class="line-clamp3"
                      :class="active ? 'text-subtitle-2' : 'text-body-2'"
                      >{{ it.title }}</v-list-item-title
                    >
                    <v-list-item-action class="dot_active" v-if="active">
                      <v-sheet color="primary" class="dot pa-0"></v-sheet>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-group>
            <v-divider></v-divider>
          </div>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "SlideLeft",
  computed: {
    ...mapGetters(["AppInfo", "isDemo", "defaultLang", "curNavKey"]),
    drawer: {
      get() {
        return this.stretch;
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    $route(val) {
      let arr = this.getCidList2(this.naviData, this.$route.path);
      if (arr.length > 0) {
        this.$store.dispatch("setNavKey", arr[arr.length - 1]["uuid"]);
      }
    },
    list(val, old) {
      // if (isNaN(val)) {
      //   this.list = val;
      //   // this.flg = 0;
      // } else {
      //   this.flg = 1;
      //   this.list = old;
      // }
      if (typeof val == "string") this.getCidList(this.naviData, val);
    },
  },
  props: {
    naviData: { default: () => [], type: Array },
    hidden: { default: false, type: Boolean },
    stretch: { default: null, type: Boolean },
  },
  mounted() {
    const that = this;
    this.list = this.curNavKey;

    if (this.$route.path) {
      let arr = this.getCidList2(this.naviData, this.$route.path);
      if (arr.length > 0) {
        this.toRouter(this.$route.path, arr[arr.length - 1]["uuid"]);
      }
    }
    that.getCidList(that.naviData, that.curNavKey);
  },
  data() {
    return {
      list: 0,
      flg: 0,
    };
  },
  methods: {
    isNumber(val) {
      var regPos = /^\d+(\.\d+)?$/; //非负浮点数
      var regNeg =
        /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (regPos.test(val) && regNeg.test(val)) {
        return true;
      } else {
        return false;
      }
    },
    isMenuActive(uuid, three = false) {
      if (this.getCidList(this.naviData, this.curNavKey).length > 3)
        return true;
      else if (three)
        return this.getCidList(this.naviData, this.curNavKey).find(
          (ele) => ele.uuid === uuid
        );
      else if (this.flg) return undefined;
      else
        return this.getCidList(this.naviData, this.curNavKey).find(
          (ele) => ele.uuid === uuid
        );
    },
    getCidList(val, id) {
      let cid_list = [];
      val.forEach((item, index) => {
        if (item.uuid == id) {
          let obj = {
            uuid: item.uuid,
            item: item,
          };
          item["open"] = false;
          cid_list = [item.uuid];
          return false;
        } else {
          if (item.menus_tree) {
            let obj = {
              uuid: item.uuid,
              item: item,
            };
            item["open"] = false;
            let newCid_list = [obj];
            let list = nodefun(item.menus_tree, id, newCid_list);
            if (list) {
              item["open"] = true;

              cid_list = list;
            }
          }
        }
      });

      // 递归函数
      function nodefun(newVal, newId, newCid_list) {
        let flag = false;
        newVal.forEach((j) => {
          if (j.uuid == newId) {
            let obj = {
              uuid: j.uuid,
              item: j,
            };
            j["open"] = true;
            newCid_list.push(obj);
            flag = true;
          } else {
            if (j.menus_tree) {
              let cid_list = JSON.parse(JSON.stringify(newCid_list));
              let obj = {
                uuid: j.uuid,
                item: j,
              };
              j["open"] = false;
              cid_list.push(obj);
              let list = nodefun(j.menus_tree, newId, cid_list);
              if (list) {
                newCid_list = list;
                j["open"] = true;
                flag = true;
              }
            }
          }
        });
        if (flag) {
          return newCid_list;
        }
      }
      return cid_list;
    },
    getCidList2(val, url) {
      let cid_list = [];
      const that = this;
      val.forEach((item, index) => {
        if (item.url == "/dashboard") {
          that.$store.dispatch("setBaseKey", item.uuid);
        }
        if (item.url == url) {
          let obj = {
            uuid: item.uuid,
            url: item.url,
            item: item,
          };
          item["open"] = false;
          cid_list = [obj];
          return false;
        } else {
          if (item.menus_tree) {
            let obj = {
              uuid: item.uuid,
              url: item.url,
              item: item,
            };
            item["open"] = false;
            let newCid_list = [obj];
            let list = nodefun2(item.menus_tree, url, newCid_list);
            if (list) {
              item["open"] = true;
              cid_list = list;
            }
          }
        }
      });
      // 递归函数
      function nodefun2(newVal, newUrl, newCid_list) {
        let flag = false;
        newVal.forEach((j) => {
          if (j.url == newUrl) {
            let obj = {
              uuid: j.uuid,
              url: j.url,
              item: j,
            };
            j["open"] = true;
            newCid_list.push(obj);
            flag = true;
          } else {
            if (j.menus_tree) {
              let cid_list = JSON.parse(JSON.stringify(newCid_list));
              let obj = {
                uuid: j.uuid,
                url: j.url,
                item: j,
              };
              j["open"] = false;
              cid_list.push(obj);
              let list = nodefun2(j.menus_tree, newUrl, cid_list);
              if (list) {
                newCid_list = list;
                j["open"] = true;
                flag = true;
              }
            }
          }
        });
        if (flag) {
          return newCid_list;
        }
      }
      return cid_list;
    },
    toRouter: function (router, uuid) {
      this.$store.dispatch("setNavKey", uuid);
      this.list = uuid;
      if (this.$route.url != router) this.$toPage(router, {});
    },
  },
};
</script>
<style scoped>
.mrc_item_active {
  font-weight: 500 !important;
}
.mrc_listitem_container {
  height: 56px !important;
}
.v-list-item__title {
  font-size: 14px !important;
  line-height: 1.4em !important;
  white-space: normal !important;
}
.dot {
  width: 4px !important;
  height: 20px !important;
}

.line-clamp3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.dot_active {
  position: absolute;
  top: 9px !important;
  right: -20px !important;
}
</style>
